/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyDay,
    JsonEventPartyDayFromJSON,
    JsonEventPartyDayFromJSONTyped,
    JsonEventPartyDayToJSON,
} from './JsonEventPartyDay';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventPartyDay
 */
export interface ApiResultOfListOfJsonEventPartyDay {
    /**
     * 
     * @type {Array<JsonEventPartyDay>}
     * @memberof ApiResultOfListOfJsonEventPartyDay
     */
    data?: Array<JsonEventPartyDay>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyDay
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventPartyDay
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyDay
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyDay
     */
    result?: ApiResultOfListOfJsonEventPartyDayResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventPartyDayResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventPartyDayFromJSON(json: any): ApiResultOfListOfJsonEventPartyDay {
    return ApiResultOfListOfJsonEventPartyDayFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventPartyDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventPartyDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventPartyDayFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventPartyDayToJSON(value?: ApiResultOfListOfJsonEventPartyDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventPartyDayToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

